import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { AttachedFileIllustration } from './AttachedFile';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const AttachedFile = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <AttachedFileIllustration title={title} />
  </IllustrationWrapper>
);
